import React from 'react'
import './css/women.css'
import { Link } from 'react-router-dom'
import { ChevronsRight} from "lucide-react";
export default function Women() {
  return (
    <>
    <div className='header-containerr'>
    <header className='header-name'>
        <h1>Women Entrepreneur</h1>
        <div>
          <ChevronsRight color="black" size={24} />
        </div>
    </header>
    </div>
  <section className="section-container">
    <div className="container">
      {/* <h2 class="section-title">Women in Business</h2>
  <p class="section-description">Leading innovation in fashion and beauty</p> */}
      <div className="grid">
        <div className="card">
          <div className="card-image">
            <Link to="/women1" >
            <img src="./images/Geena-Jackson.jpg" alt="Geena Jackson" />
            </Link>
          </div>
          <Link to="/women1"className='anchor' >
            <div className='text-padding'>
          <h3 className="card-name">Geena Jackson</h3>
          <p className="card-role">
          Founder &amp; President , Sparkly Frog Clan Productions Inc..
          </p>
          <blockquote className="card-quote">
            "Innovation in business doesn't have to come at the environment's
            expense."
          </blockquote>
          <p className="card-impact">
          Sparkly Frog Clan Productions Inc.
          </p>
          </div>
          </Link>
        </div>
        <div className="card">
          <div className="card-image">
            <Link to="women2">
            <img src="./images/Meghan-Duffy.jpg" alt="Meghan Duffy" />
            </Link>
          </div>
          <Link to="women2" className='anchor'>
            <div className='text-padding'>
          <h3 className="card-name">Meghan Duffy</h3>
          <p className="card-role">Canadian Women</p>
          <blockquote className="card-quote">
            "Empowering women through innovative design and inclusivity."
          </blockquote>
          <p className="card-impact">
            Leading diversity initiatives in luxury fashion
          </p>
          </div>
          </Link>
        </div>
        <div className="card">
          <div className="card-image">
            <Link to="women3">
            <img src="./images/Melissa-Munro.jpg" alt="Melissa Munro" />
            </Link>
          </div>
          <Link to="women3" className='anchor'>
            <div className='text-padding'>
          <h3 className="card-name">Melissa Munro</h3>
          <p className="card-role">healthcare entrepreneur</p>
          <blockquote className="card-quote">
            "Technology can revolutionize how we approach beauty and self-care."
          </blockquote>
          <p className="card-impact">Pioneering AI-driven skincare solutions</p>
          </div>
          </Link>
        </div>
        <div className="card">
          <div className="card-image">
            <Link to="women4">
            <img src="./images/Norah-Galea.jpg" alt="Norah galea" />
            </Link>
          </div>
          <Link to="women4" className='anchor'>
            <div className='text-padding'>
          <h3 className="card-name">Norah galea</h3>
          <p className="card-role">Owner and Creator of Knock Thrice Inc.</p>
          <blockquote className="card-quote">
            "Technology can revolutionize how we approach beauty and self-care."
          </blockquote>
          <p className="card-impact">Pioneering AI-driven skincare solutions</p>
          </div>
          </Link>
        </div>
      </div>
    </div>
    <header className="site-header">
    <h1></h1>
    <Link to="" className="link-more">
      Load More »»
    </Link>
  </header>
  </section>
</>

  )
}
